import { useEffect } from 'react';
import { Navigate, useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import { useCurrentUser } from '../hooks/useCurrentUser';
import { useSubscriptionStatus } from '../hooks/useSubscriptionStatus';
import HelperFunctions from '../helpers/HelperFunctions';
import Loader from '../templates/Loader';

// Eagerly imported (not React.lazy): this is the public "/" landing page and the
// LCP route. Lazy-loading it forced a second JS round-trip after the main bundle
// parsed — the hero/teaser <img> couldn't render until that chunk arrived, which
// pushed LCP to ~7.8s despite the image bytes being preloaded in index.html. As a
// static import it joins the initial module graph (Vite emits a modulepreload),
// so the hero renders close to FCP. The page itself code-splits everything below
// the fold (see LandingBelowFold) to keep the entry bundle small.
import LoggedOutHomePlusTwo from '../pages/LoggedOutHome/CorporateLandingPage/LoggedOutHomePlusTwo';

const HomeRouter = () => {
    const [currentUser] = useCurrentUser();
    const { doesUserHaveSubscription } = HelperFunctions();
    const { subscriptionData, status: subscriptionStatus } = useSubscriptionStatus();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate()

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            loggedIn: !!currentUser,
        });
    }, [currentUser]);


    if (currentUser) {
        // want to navigate to trial expired page only
        // if user hasnt just subscribed

        if (searchParams.get('checkout-complete') !== 'saas-subscription') {
            //debugger;
            if (!doesUserHaveSubscription(currentUser.roles)) {
                // Still waiting on the Stripe subscription fetch — don't route
                // until we know whether there's a lapsed subscription or none at all.
               

                if (subscriptionData === null || subscriptionData.status === null ) {
                    return <div className='vh-100 center-content'><Loader /></div>;
                }
               
                if (subscriptionStatus && subscriptionStatus !== 'active' && subscriptionStatus !== 'trialing') {
                    return <Navigate to="/trial-expired" state={{ from: location }} />;
                }
                return <Navigate to="/sign-up/finish" state={{ from: location }} />;
            } else {
                return <Navigate to="/dashboard" state={{ from: location }} />;
            }
        } else if (searchParams.get('checkout-complete') === 'saas-subscription') {

            navigate({
                pathname: "/dashboard",
                search: window.location.search
            });

            return;
        } else {
            return <Navigate to="/dashboard" state={{ from: location }} />;
        }




    }

    return <LoggedOutHomePlusTwo />;
};

export default HomeRouter;
